import InstantWinDetailPreviewPanel from "./instantWinDetailPreviewPanel.container";

export default InstantWinDetailPreviewPanel;
